var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    { attrs: { align: "center" } },
    [
      _c(
        "v-col",
        { attrs: { cols: "12" } },
        [
          _c("v-autocomplete", {
            attrs: {
              outlined: "",
              multiple: "",
              "hide-details": "",
              dense: "",
              "item-value": "id",
              "item-text": "title",
              "no-data-text": "Список пуст",
              placeholder: "Начните вводить для поиска...",
              items: _vm.entities,
              value: _vm.value,
              disabled: _vm.$apollo.queries.entities.loading,
              loading: _vm.$apollo.queries.entities.loading,
              "search-input": _vm.search,
            },
            on: {
              "update:searchInput": function ($event) {
                _vm.search = $event
              },
              "update:search-input": function ($event) {
                _vm.search = $event
              },
              change: _vm.updateValueHandler,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }